import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { getStoredOrgSlug, isSignedIn } from '@/app/auth';

// /$orgId — layout route for every tenant-scoped page. Renders an
// Outlet; the actual screens live in $orgId.fleet.tsx, $orgId.settings.tsx,
// etc. The beforeLoad here is the slug-mismatch guard: if the URL
// slug doesn't match the signed-in tenant, redirect to the right
// one. Backend tenant scoping comes from the JWT — this guard is
// UX-only (clean URLs, no cross-org bookmarks rendering empty data).
export const Route = createFileRoute('/$orgId')({
  beforeLoad: ({ params, location }) => {
    if (!isSignedIn()) return; // root guard already handles the redirect to /auth
    const expected = getStoredOrgSlug();
    if (!expected) return;
    if (params.orgId === expected) return;
    // Slug mismatch — replace the bad segment with the correct one
    // so the deep link still works (e.g. someone shared /acme/fleet/42
    // with a user signed in as beta — they should land on /beta/fleet/42).
    const rest = location.pathname.replace(/^\/[^/]+/, '');
    // Runtime-computed path (slug + deep rest) — use href, not the typed `to`.
    throw redirect({ href: `/${expected}${rest}` });
  },
  component: () => <Outlet />,
});
